import React, {useState } from 'react'
import AnswerTypes from './small_components/AnswerTypes';
import { ref, getDownloadURL, uploadBytesResumable } from "firebase/storage";
import {storage} from '../firebase-config'

function FileUpload({ state, currentQuestion, handleChange, language }) {
const [progress, setProgress] = useState(0);

const formHandler = (e) => {
    e.preventDefault();
    const file = e.target.files[0];
    uploadFiles(file);
};

const uploadFiles = (file) => {
    if (!file) return;
    const sotrageRef = ref(storage, state.email + `/${file.name}`);
    const uploadTask = uploadBytesResumable(sotrageRef, file);

    uploadTask.on(
        "state_changed",
        (snapshot) => {
            const prog = Math.round(
                (snapshot.bytesTransferred / snapshot.totalBytes) * 100
            );
            setProgress(prog);
        },
        () => {
            getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
            });
        }
    );
};

function UploadSection() {
    if (progress === 0) {
        return (
            <div className="file-dummy">
                <div>Please upload your Raw DNA File here</div>
            </div>
        )
    }
    else if (progress > 0 && progress < 100) {
        return (
            <div className="file-dummy">
                <div>Uploading...{progress}%</div>
            </div>
        )
    }
    else if (progress === 100) {
        const styles = {
            border: '1px solid rgba(0, 255, 0, 0.4)"',
            backgroundColor: "rgba(0, 255, 0, 0.3)"
        };
        return (
            <div className="file-dummy" style={styles}>
                <div>Your DNA data has been uploaded! You can continue.</div>
            </div>
        )
    }
}

if (state.dna_file === "Yes" || state.dna_file === "有") {
    return (
        <div>
            <AnswerTypes
                name="dna_file"
                value={state.dna_file ?? " "}
                handleChangeAndAnswer={handleChange}
                currentQuestion={currentQuestion}
                language={language}
                type="radio" />
            <div className="form-group file-area">
                <input type="file" name="images" id="images" required="required" onChange={formHandler} />
                <UploadSection />
            </div>
        </div >
    )
} else {
    return (
        <AnswerTypes
            name="dna_file"
            value={state.dna_file ?? " "}
            handleChangeAndAnswer={handleChange}
            currentQuestion={currentQuestion}
            language={language}
            type="radio" />
    )
}
}

export default FileUpload